export default class DrawingCanvas extends Phaser.Sprite
{
    constructor(game, config, userBrush, image)
    {
        super(game);

        this.config = config;

        this.userBrush = userBrush;
        this.bitmapData = this.game.make.bitmapData(this.config.transform.size.width, this.config.transform.size.height);
        this.bitmapData.draw(image, 0, 0);
        this.bitmapData.blendDestinationOut();

        this.alwaysDraw = false;
        this.isOver = false;
        this.isDown = false;
        this.lastDrawX = null;
        this.lastDrawY = null;
        this.drewThisFrame = false;

        this.loadTexture(this.bitmapData);
        this.position.set(this.config.transform.position.x, this.config.transform.position.y);
        this.inputEnabled = true;
        this.events.onInputOver.add(this.onOver, this);
        this.events.onInputOut.add(this.onOut, this);
        this.events.onInputDown.add(this.onDown, this);
        this.events.onInputUp.add(this.onUp, this);

        this.dirty = false;
        this.onDraw = new Phaser.Signal();
        this.bitmapData.update();
        this.refreshBrush = false;
    }

    postUpdate()
    {
        this.drewThisFrame = false;

        if(this.refreshBrush)
        {
            this.resetBrushPosition();
            this.refreshBrush = false;
        }

        if (this.isOver || this.alwaysDraw)
        {
            var drawX = this.userBrush.x - this.x;
            var drawY = this.userBrush.y - this.y;

            // Check if the coordinates are within the drawing area
            if(drawX < -this.userBrush.width || drawX > this.bitmapData.width + this.userBrush.width
                || drawY < -this.userBrush.height || drawY > this.bitmapData.height + this.userBrush.height)
            {
                this.lastDrawX = drawX;
                this.lastDrawY = drawY;
                this.refreshBrush = true;
                return;
            }

            if (this.lastDrawX !== drawX || this.lastDrawY !== drawY)
            {
                var linePoints = bresenhamLine(this.lastDrawX, this.lastDrawY, drawX, drawY);
                for (var i = 0; i < linePoints.length; i+=2)
                {
                    linePoints[i].x -= this.userBrush.width * 0.5;
                    linePoints[i].y -= this.userBrush.height * 0.5;
                    this.bitmapData.draw(this.userBrush, linePoints[i].x, linePoints[i].y);
                }

                this.lastDrawX = drawX;
                this.lastDrawY = drawY;

                this.bitmapData.update();
                this.bitmapData.render(); // required on webgl, does nothing on canvas

                this.dirty = true;
                this.drewThisFrame = true;
            }
        }
    }

    destroy()
    {
        this.onDraw.dispose();
        this.bitmapData.baseTexture.destroy();
        this.bitmapData.destroy();
        delete this.bitmapData;
        this.userBrush = null;
        super.destroy();
    }

    onOver(gameObject, pointer)
    {
        this.isOver = true;
        //this.isDown = false;
        this.stopStroke();
        this.refreshBrush = true;
    }

    onOut(gameObject, pointer)
    {
        //this.isOver = false;
        //this.stopStroke();
        this.stopStroke();
        this.refreshBrush = true;
    }

    onDown(gameObject, pointer)
    {
        this.isDown = true;
        this.stopStroke();
        this.refreshBrush = true;
    }

    onUp(gameObject, pointer)
    {
        this.stopStroke();
        this.refreshBrush = true;
    }

    stopStroke()
    {
        this.isDown = false;
        this.lastDrawX = null;
        this.lastDrawY = null;

        if(this.dirty)
        {
            this.onDraw.dispatch();
            this.dirty = false;
        }
    }

    resetBrushPosition()
    {
        this.lastDrawX = this.userBrush.x - this.x;
        this.lastDrawY = this.userBrush.y - this.y;
    }
}

function bresenhamLine(x1, y1, x2, y2)
{
    var points = [];

    x1 |= 0;
    y1 |= 0;
    x2 |= 0;
    y2 |= 0;

    var dx = x2 - x1;
    var dy = y2 - y1;
    var absX = Math.abs(dx);
    var absY = Math.abs(dy);

    if (absY <= absX)
    {
        if (dx < 0)
        {
            var x = x1;
            x1 = x2;
            y1 = y2;
            x2 = x;
        }
        points.push({x: x1, y: y1});
        var xx = 2 * absY - absX;

        for (var i = x1; i < x2; i++)
        {
            ++x1;
            if (xx < 0)
            {
                xx += 2 * absY;
            }
            else
            {
                if ((dx < 0 && dy < 0) || (dx > 0 && dy > 0))
                {
                    ++y1;
                }
                else
                {
                    --y1;
                }
                xx += 2 * (absY - absX);
            }
            points.push({x: x1, y: y1});
        }
    }
    else
    {
        if (dy < 0)
        {
            var y = y1;
            x1 = x2;
            y1 = y2;
            y2 = y;
        }
        points.push({x: x1, y: y1});
        var yy = 2 * absX - absY;

        for (var i = y1; i < y2; i++)
        {
            ++y1;
            if (yy <= 0)
            {
                yy += 2 * absX;
            }
            else
            {
                if ((dx < 0 && dy < 0) || (dx > 0 & dy > 0))
                {
                    ++x1;
                }
                else
                {
                    --x1;
                }
                yy += 2 * (absX - absY);
            }
            points.push({x: x1, y: y1});
        }
    }
    return points;
}
